import React from 'react';
import { NumericFormat } from 'react-number-format';

interface PriceInputProps {
  value: number | string;
  onChange: (value: number) => void;
  currency?: string;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  title?: string;
  allowNegative?: boolean;
  decimalScale?: number;
  fixedDecimalScale?: boolean;
}

const PriceInput: React.FC<PriceInputProps> = ({
  value,
  onChange,
  currency = '',
  className = '',
  placeholder = '',
  disabled = false,
  onFocus,
  title = 'Düzenlemek için tıklayın',
  allowNegative = false,
  decimalScale = 4,
  fixedDecimalScale = true
}) => {
  const safeNumericValue =
    typeof value === 'number' && Number.isFinite(value)
      ? value
      : typeof value === 'string'
        ? (() => {
            const n = parseFloat(String(value).trim().replace(',', '.'));
            return Number.isFinite(n) ? n : 0;
          })()
        : 0;

  const inputClassName = ['tabular-nums', className].filter(Boolean).join(' ');

  return (
    <NumericFormat
      className={inputClassName}
      value={safeNumericValue}
      onValueChange={(values) => {
        if (values.value === '') {
          onChange(0);
        } else {
          onChange(values.floatValue || 0);
        }
      }}
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={decimalScale}
      fixedDecimalScale={fixedDecimalScale}
      allowNegative={allowNegative}
      onFocus={onFocus}
      title={title}
      placeholder={placeholder}
      disabled={disabled}
      suffix={currency ? ` ${currency}` : ''}
    />
  );
};

export default PriceInput;
